<template>
    <div class="cadastro-usuario">
        <div class="card-cadastrar-usuario">
            <g-card :expansivel="true" :comecaFechado="false">
              <template #cabecalho>
                    <div class="header-filtros">
                    <div class="titulo-filtros-cabecalho"> {{ Titulo }} </div>
                    <div class="header-icons">
                        <g-button
                        class="trash-box"
                        tipo="cinza" altura="35px"
                        largura="45px"
                        icone="icone_lixo.svg"
                        tamanhoIcone="15px"
                        somenteIcone
                        :sombreado="false"
                        v-tooltip="'Limpar filtro'"
                        @click="limpaInfo"
                        />
                    </div>
                </div>
              </template>        
                <g-form>
                    <div class="conteudo espacamento-filtros">
                        <div class="dados-usuario">
                            <div class="titulo-conteudo-filtros"> Usuário <strong class="asterisco-obrigatorio">*</strong></div>
                            <PInputText
                            v-model="objFiltro.NomeUsuario"
                            placeholder="Insira o nome do usuário"
                            >
                            </PInputText>
                        </div>
                        <div class="dados-login">
                            <div class="titulo-conteudo-filtros"> Login <strong class="asterisco-obrigatorio">*</strong></div>
                            <PInputText
                            :disabled="modoEdicao"
                            v-model="objFiltro.Login"
                            placeholder="Insira o login do usuário"
                            >
                            </PInputText>
                        </div>
                        <div class="dados-codigo-nova-senha">
                            <div class="titulo-conteudo-filtros"> Nova Senha<strong class="asterisco-obrigatorio">*</strong></div>
                            <span class="divSenha p-input-icon-left">
                                <PInputText
                                :disabled="!EditarSenha"
                                :type="tipo"
                                :class="{'p-invalid':v$.senhaNova.$invalid && submit}" v-model="v$.senhaNova.$model"
                                placeholder="Insira a nova senha"
                                >
                                </PInputText>
                                <i v-on:click="mostrarSenha" class="pi pi-eye olho "></i>
                            </span>
                        </div>
                        <div class="dados-confirmacao-senha">
                            <div class="titulo-conteudo-filtros"> Confirmação da Senha <strong class="asterisco-obrigatorio">*</strong></div>
                            <span class="divSenha p-input-icon-left">
                                <PInputText
                                :type="tipo"
                                :disabled="!EditarSenha"
                                v-model="senhaNovaConfirmacao"
                                placeholder="Insira a confirmação da senha"
                                >
                                </PInputText>
                                <i v-on:click="mostrarSenha" class="pi pi-eye olho "></i>
                            </span>
                        </div>
                        
                        <div class="dados-confirmacao-senha">
                            <div class="titulo-conteudo-filtros"> Email <strong class="asterisco-obrigatorio">*</strong></div>
                            <PInputText
                            v-model="objFiltro.Email"
                            placeholder="Insira o email do usuário"
                            >
                            </PInputText>
                        </div>
                        <div class="checks-container">
                            <div class="bloqueado-checkbox">
                                <PCheckBox
                                :binary="true"
                                v-model="objFiltro.Bloqueado"
                                ></PCheckBox>
                                <label class="label-checkbox" for="ext"> Bloqueado? </label>
                            </div>
                            <div class="inativo-checkbox">
                                <PCheckBox
                                :binary="true"
                                v-model="objFiltro.Inativo"
                                ></PCheckBox>
                                <label class="label-checkbox" for="ext"> Inativo? </label>
                            </div>
                        </div>
                        <div class="data-ultima-senha">
                            <div class="titulo-conteudo-filtros"> Última troca de Senha </div>
                                <g-date-input
                                class="ultima-venda-termino-input input-label"
                                alturainput="40px"
                                largurainput="100%"
                                tamanhobotao="35px"
                                invertido
                                v-model="objFiltro.DataTrocaSenha"
                                disabled
                                ></g-date-input>
                        </div>  
                        <div class="checks-container" v-if= this.modoEdicao>
                            <div class="bloqueado-checkbox">
                                <PCheckBox
                                :binary="true"
                                v-model="EditarSenha"
                                ></PCheckBox>
                                <label class="label-checkbox" for="ext"> Editar Senha? </label>
                            </div>
                        </div>
                        <div class="grupo-conteudo">
                                <div class="titulo-linha">
                                    <div class="titulo-conteudo-filtros"> Grupo do usuário <strong class="asterisco-obrigatorio"> *</strong></div>
                                </div>
                                <div class="tipo-nome-produto">
                                <div class="grupo-dropdown">
                                    <div class="sequencia-produto">
                                        <PDropDown
                                            class="situacao-input input-label"
                                            :filter="true"
                                            optionLabel="nomeGrupo"
                                            optionValue="id"
                                            :options="GrupoArrayDropDown"
                                            placeholder="Selecione o Grupo"
                                            v-model="objFiltro.GrupoSelecionado"
                                            >
                                        </PDropDown>
                                    </div>
                                </div>        
                            </div>
                        </div>
                    </div>    
                </g-form>
                <div class="buttons-next-back">
                    <div class="button-next">
                        <g-button
                        tipo="amarelo"
                        negritoTexto
                        altura="35px"
                        largura="100%"
                        @click="gravar"
                        >
                            GRAVAR
                        </g-button>
                    </div>
                    <div class="button-back">
                        <g-button
                        tipo="cinza"
                        altura="35px"
                        largura="100%"
                        negritoTexto
                        @click="voltar()"
                        >
                            VOLTAR
                        </g-button>
                    </div>
                </div>
            </g-card>
        </div>
        <PDialog :modal="true" :showHeader="false" :closable="false" v-model:visible="popupExistente">
            <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Login {{ this.objFiltro.Login }} já encontrado. Deseja continuar e alterar as informações deste usuário? </div>
            <div class="botoes-popup">
                <div>
                <g-button
                tipo="cinza"
                negritoTexto 
                largura="200px" 
                altura="35px" 
                @click="limpaInfo"
                >
                    NÃO
                </g-button>
                </div>
                <div>
                <g-button
                negritoTexto
                largura="200px" 
                altura="35px" 
                @click="TrocaPraEdicao"
                >
                    SIM
                </g-button>
                </div>
            </div>
        </PDialog>       
    </div>
</template>

<script>
import CadastroUsuario from './CadastroUsuario.js' 
export default CadastroUsuario
</script>

<style scoped>
.p-input-icon-left > .p-inputtext {
    padding-left: 1.5%;
}
.divSenha {
    width: 100%;
    display: flex;
}
.olho {  
    margin-left: 89%;
    color: #6c757d;
}
    @media (min-width:310px) {

        .plus-btn{
            width: 14em;
        }

        .checks-container {
            display: flex;
            column-gap: 2rem;
            padding: 1rem 0;
        }

        .grupo-conteudo {
            margin-top: 2rem;
        }

        .grupo-dropdown {
            display: flex;
            flex-direction: column;
            row-gap: 1rem;
            /* margin-bottom: 2rem; */
        }

        .sequencia-adicionar-produto-desktop {
            display: flex;
            justify-content: center;
        }

        .grid{
            margin: 0;
            padding: 0;
        }

    }

    @media (min-width:368px) {

    }

    @media (min-width:500px) {

    }

    @media (min-width:801px) {
       
        .olho {
            margin-left: 85%;
        }
    }

    @media (min-width:1025px) { 
    .conteudo{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 2rem;
    }

    .checks-container{
        align-items: center;
        row-gap: 1rem;
        align-items: end;
        padding-bottom: 1rem;
    }

    .grupo-conteudo {
        grid-area: 3 / 1 / 4 / 3;
        margin-top: 1rem;
    }
    .sequencia-produto {
        width: 90%;
    }

    .grupo-dropdown {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }

    .plus-btn{
            width: 40px;
        }

    }

    @media (min-width:1281px) { 
    }


</style>
